
import React, { useState } from 'react';
import { tournamentsData, promotionsData } from '../../../mocks/tournaments';

export const TournamentsSection: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'tournaments' | 'promotions'>('tournaments');

  const getStatusBadge = (status: string) => {
    switch (status) {
      case 'active':
        return <span className="px-2 py-1 bg-emerald-100 text-emerald-700 rounded-full text-xs font-medium">Активен</span>;
      case 'upcoming':
        return <span className="px-2 py-1 bg-amber-100 text-amber-700 rounded-full text-xs font-medium">Скоро</span>;
      default:
        return <span className="px-2 py-1 bg-gray-100 text-gray-700 rounded-full text-xs font-medium">Завершен</span>;
    }
  };

  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 bg-amber-100 text-amber-700 rounded-full text-sm font-medium mb-4">
            Турниры и акции
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Турниры в <span className="text-amber-600">мобильных казино онлайн</span>
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Участвуйте в турнирах и получайте дополнительные бонусы от лучших онлайн казино России
          </p>
        </div>

        <div className="flex justify-center mb-8">
          <div className="bg-gray-100 p-1 rounded-full inline-flex">
            <button
              onClick={() => setActiveTab('tournaments')}
              className={`px-6 py-2.5 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                activeTab === 'tournaments'
                  ? 'bg-white text-gray-900 shadow-sm'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              <i className="ri-trophy-line mr-2"></i>
              Турниры
            </button>
            <button
              onClick={() => setActiveTab('promotions')}
              className={`px-6 py-2.5 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                activeTab === 'promotions'
                  ? 'bg-white text-gray-900 shadow-sm'
                  : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              <i className="ri-gift-line mr-2"></i>
              Акции
            </button>
          </div>
        </div>

        {activeTab === 'tournaments' && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {tournamentsData.map((tournament) => (
              <div
                key={tournament.id}
                className="bg-white rounded-2xl shadow-md overflow-hidden hover:shadow-xl transition-all duration-300 group"
              >
                <div className="relative h-40 overflow-hidden">
                  <img
                    src={tournament.image}
                    alt={tournament.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 right-3">
                    {getStatusBadge(tournament.status)}
                  </div>
                </div>
                <div className="p-5">
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-xs text-gray-500">{tournament.casino}</span>
                    <span className="text-xs text-gray-500">{tournament.startDate} - {tournament.endDate}</span>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-3">{tournament.name}</h3>
                  <div className="flex items-center justify-between mb-4">
                    <div>
                      <div className="text-2xl font-bold text-amber-600">{tournament.prizePool}</div>
                      <div className="text-xs text-gray-500">Призовой фонд</div>
                    </div>
                    {tournament.participants > 0 && (
                      <div className="text-right">
                        <div className="text-lg font-semibold text-gray-900">{tournament.participants.toLocaleString()}</div>
                        <div className="text-xs text-gray-500">Участников</div>
                      </div>
                    )}
                  </div>
                  <p className="text-sm text-gray-600 mb-4">{tournament.rules}</p>
                  <button className="w-full py-2.5 bg-amber-600 text-white rounded-lg font-medium hover:bg-amber-700 transition-colors cursor-pointer whitespace-nowrap">
                    Участвовать
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}

        {activeTab === 'promotions' && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {promotionsData.map((promo) => (
              <div
                key={promo.id}
                className="bg-white rounded-2xl shadow-md p-6 hover:shadow-xl transition-all duration-300 flex items-center gap-5"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-amber-400 to-rose-500 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className={`text-white text-2xl ${
                    promo.type === 'cashback' ? 'ri-refund-2-line' :
                    promo.type === 'freespins' ? 'ri-loader-4-line' :
                    promo.type === 'birthday' ? 'ri-cake-2-line' :
                    'ri-percent-line'
                  }`}></i>
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-xs text-gray-500">{promo.casino}</span>
                    <span className="text-xs text-amber-600">до {promo.validUntil}</span>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-1">{promo.title}</h3>
                  <p className="text-sm text-gray-600">{promo.description}</p>
                </div>
                <div className="text-right flex-shrink-0">
                  <div className="text-xl font-bold text-amber-600">{promo.value}</div>
                  <button className="mt-2 px-4 py-1.5 bg-amber-100 text-amber-700 rounded-lg text-sm font-medium hover:bg-amber-200 transition-colors cursor-pointer whitespace-nowrap">
                    Получить
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
